<template>
  <el-container style="height: 100%">
    <el-aside v-if="userRole.authority <= 2 && outSizeLogin!=1" style="width: 200px">
      <ui-aside />
    </el-aside>
    <el-container>
      <el-header class="myHead" v-if="outSizeLogin!=1">
        <ui-header />
      </el-header>
      <el-main class="myMain">
        <el-container>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </el-container>
      </el-main>
      <el-footer v-if="outSizeLogin!=1">
        <ui-footer />
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import uiHeader from './UiHeader.vue'
import UiAside from './UiAside'
import uiFooter from './UiFooter.vue'

export default {
  name: 'index',
  components: {
    UiAside,
    uiHeader,
    uiFooter
  },
  data() {
    return {
      userRole: '',
      outSizeLogin: '',
    }
  },
  created() {
    this.userRole = JSON.parse(sessionStorage.getItem('userRole'))
  },
  mounted() {
    if(sessionStorage.getItem('outSizeLogin')){
      this.outSizeLogin = JSON.parse(sessionStorage.getItem('outSizeLogin'))
    }
  },
}
</script>
<style>
.myHead {
  padding: 0;
}
.myMain {
  padding: 0 10px;
  flex: 9;
}
/*定义标题栏*/
.page-header {
  background-color: #ffffff;
  margin-bottom: 1rem;
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: bold;
  text-align: left;
}

.page-header-btn {
  text-align: right;
}
</style>
<style scoped>
.fade-enter {
  visibility: hidden;
  opacity: 0;
}

.fade-leave-to {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-to,
.fade-leave {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue